/**
 * アセットのアップロード機能を提供します。
 * @deprecated
 * @requires jQuery, mtappVars
 */
import { removeHost } from '../removeHost.js';

export const assetField = {
    cleanup: function () {
        mtappVars.assetField = {
            fieldId: '',
            assetId: '',
            assetList: {},
            assetType: 'image'
        };
    },
    init: function () {
        const self = this;
        self.cleanup();
        jQuery('#mtapp-asset-field').mtModal();
        jQuery('.mt-modal')
            .off('hidden.bs.modal.assetField')
            .on('hidden.bs.modal.assetField', function () {
                const assetFieldObj = window.top.mtappVars.assetField;
                if (assetFieldObj.assetId !== '') {
                    const target = document.getElementById(assetFieldObj.fieldId);
                    target.value = assetFieldObj.assetId;
                    target.dispatchEvent(mtappVars.eventInput);
                    const updateItemIdButton = target.previousElementSibling;
                    const targetThumbnail = document.getElementById(assetFieldObj.fieldId + '-thumb');
                    const targetUrl = document.getElementById(assetFieldObj.fieldId + '-url');
                    // すでにアップロードされているアセットから選択された場合
                    if (typeof assetFieldObj.assetList['asset-' + assetFieldObj.assetId + '-json'] === 'string') {
                        const assetDetails = JSON.parse(assetFieldObj.assetList['asset-' + assetFieldObj.assetId + '-json']);
                        targetUrl.value = removeHost(assetDetails.url);
                        targetUrl.dispatchEvent(mtappVars.eventInput);
                        if (assetFieldObj.assetType === 'image') {
                            targetThumbnail.value = removeHost(assetDetails.preview_url);
                            targetThumbnail.dispatchEvent(mtappVars.eventInput);
                        }
                        if (updateItemIdButton) {
                            jQuery(updateItemIdButton).trigger('click');
                        }
                        self.cleanup();
                    } else {
                        jQuery
                            .ajax({
                                url: [
                                    mtappVars.dataapi_script_url,
                                    'v' + mtappVars.dataapi_default_version,
                                    'sites',
                                    mtappVars.blog_id,
                                    'assets',
                                    assetFieldObj.assetId
                                ].join('/'),
                                dataType: 'json'
                            })
                            .done(function (response) {
                                targetUrl.value = removeHost(response.url);
                                targetUrl.dispatchEvent(mtappVars.eventInput);
                                if (assetFieldObj.assetType !== 'image') {
                                    if (updateItemIdButton) {
                                        jQuery(updateItemIdButton).trigger('click');
                                    }
                                    self.cleanup();
                                }
                            });
                        // 画像の場合のサムネイルの処理
                        if (assetFieldObj.assetType === 'image') {
                            jQuery
                                .ajax({
                                    url: [
                                        mtappVars.dataapi_script_url,
                                        'v' + mtappVars.dataapi_default_version,
                                        'sites',
                                        mtappVars.blog_id,
                                        'assets',
                                        assetFieldObj.assetId,
                                        'thumbnail'
                                    ].join('/'),
                                    data: {
                                        width: 120,
                                        height: 120
                                    },
                                    dataType: 'json'
                                })
                                .done(function (response) {
                                    targetThumbnail.value = removeHost(response.url);
                                    targetThumbnail.dispatchEvent(mtappVars.eventInput);
                                    if (updateItemIdButton) {
                                        jQuery(updateItemIdButton).trigger('click');
                                    }
                                    self.cleanup();
                                });
                        }
                    }
                } else {
                    self.cleanup();
                }
            });
    },
    select: function (id, type) {
        if (typeof type !== 'string') {
            type = 'image';
        }
        mtappVars.assetField.fieldId = id;
        mtappVars.assetField.assetType = type;
        const trigger = jQuery('#mtapp-asset-field');
        const url = trigger.attr('href').replace(/(filter_val|require_type)=(\w+)/g, '$1=' + type);
        trigger.attr('href', url).trigger('click');
        return false;
    },
    remove: function (id) {
        const idField = document.getElementById(id);
        const updateItemIdButton = idField.previousElementSibling;
        const thumbField = document.getElementById(id + '-thumb');
        const urlField = document.getElementById(id + '-url');
        if (idField) {
            idField.value = '';
            idField.dispatchEvent(mtappVars.eventInput);
        }
        if (thumbField) {
            thumbField.value = '';
            thumbField.dispatchEvent(mtappVars.eventInput);
        }
        if (urlField) {
            urlField.value = '';
            urlField.dispatchEvent(mtappVars.eventInput);
        }
        if (updateItemIdButton) {
            jQuery(updateItemIdButton).trigger('click');
        }
    },
    publicUrl: function (path) {
        if (!path) {
            return '';
        } else if (/^http/.test(path)) {
            return path;
        } else if (/__mode=thumbnail_image/.test(path)) {
            return `${location.protocol}//${location.host}` + path;
        } else {
            return mtappVars.site.site_url.replace(/(https?:\/\/[^/]+).*/, '$1') + path;
        }
    }
};
